import { temporarilyNotSupport } from '../../utils'

// Wi-Fi
export const stopWifi = /* @__PURE__ */ temporarilyNotSupport('stopWifi')
export const startWifi = /* @__PURE__ */ temporarilyNotSupport('startWifi')
export const setWifiList = /* @__PURE__ */ temporarilyNotSupport('setWifiList')
export const onWifiConnectedWithPartialInfo = /* @__PURE__ */ temporarilyNotSupport('onWifiConnectedWithPartialInfo')
export const onWifiConnected = /* @__PURE__ */ temporarilyNotSupport('onWifiConnected')
export const onGetWifiList = /* @__PURE__ */ temporarilyNotSupport('onGetWifiList')
export const offWifiConnectedWithPartialInfo = /* @__PURE__ */ temporarilyNotSupport('offWifiConnectedWithPartialInfo')
export const offWifiConnected = /* @__PURE__ */ temporarilyNotSupport('offWifiConnected')
export const offGetWifiList = /* @__PURE__ */ temporarilyNotSupport('offGetWifiList')
export const getWifiList = /* @__PURE__ */ temporarilyNotSupport('getWifiList')
export const getConnectedWifi = /* @__PURE__ */ temporarilyNotSupport('getConnectedWifi')
export const connectWifi = /* @__PURE__ */ temporarilyNotSupport('connectWifi')
